'use strict';
var getCardatronCards, getDivisionLocLatLng, getLatLng, getSearchLocLatLng, ls_ttl, setCards, template, tracky, ttl_ms,
  hasProp = {}.hasOwnProperty;

ls_ttl = require('localstorage-ttl');

tracky = require('../../../src/frontend/helper/general/m_trackEvent');

template = require('../../gig_body/header/sub_nav/components/cards/cards.html.mustache');

ttl_ms = 1000 * 60 * 60;

setCards = function(data) {
  var $navContainer, $subNavCardatron, cuiClass, key, rendered, tilesLeft, value;
  for (key in data) {
    if (!hasProp.call(data, key)) continue;
    value = data[key];
    $navContainer = $("#subnav-" + key + "-tab");
    $subNavCardatron = $navContainer.find('.subnav-cardatron');
    if ($subNavCardatron.length) {
      if (_.isEmpty(value) || _.isEmpty(value.cards)) {
        tracky('ls-cardatron-render-error', {
          err: key + " response doesn't contain cards"
        });
        $subNavCardatron.remove();
      } else {
        tilesLeft = 4 - $navContainer.find('.subnav-categories').length;
        cuiClass = (function() {
          switch (tilesLeft) {
            case 4:
              return 'cui-four-up';
            case 3:
              return 'cui-three-up';
            case 2:
              return 'cui-two-up';
            case 1:
              return 'cui-one-up';
          }
        })();
        value.cards = value.cards.slice(0, tilesLeft);
        rendered = template.render(value);
        $subNavCardatron.replaceWith(rendered);
        $subNavCardatron = $navContainer.find('.subnav-cards').addClass(cuiClass);
      }
    }
  }
};

getSearchLocLatLng = function() {
  var config;
  try {
    config = JSON.parse(Cookie.get('search_loc'));
    return config.lat + "," + config.lng;
  } catch (error) {
    return '';
  }
};

getDivisionLocLatLng = function() {
  var ref, ref1;
  if (Groupon.division != null) {
    return ((ref = Groupon.division) != null ? ref.lat : void 0) + "," + ((ref1 = Groupon.division) != null ? ref1.lng : void 0);
  } else {
    return '';
  }
};

getLatLng = function() {
  var ell;
  ell = getSearchLocLatLng() || getDivisionLocLatLng();
  Cookie.set('ell', ell);
  return ell;
};

getCardatronCards = function() {
  var brand, cacheData, cll, division, ell, ref, ref1, storageKey;
  ell = Cookie.get('ell');
  cll = Cookie.get('cll');
  if (ell == null) {
    ell = getLatLng();
  }
  division = ((ref = Groupon.division) != null ? ref.id : void 0) || '';
  storageKey = 'sls_cardatron_cards';
  brand = $('head').data('brand');
  try {
    cacheData = ls_ttl.get(storageKey);
  } catch (error) {}
  if ((cacheData != null) && cacheData.division === division && cacheData.brand === brand) {
    if (cacheData.cll === cll && cacheData.ell === ell) {
      setCards(cacheData.cards);
      return;
    }
  }
  $.ajax({
    type: 'GET',
    url: [(ref1 = Groupon.endpoints) != null ? ref1.cards : void 0, 'v1'].join('/'),
    headers: {
      'x-ls-client-req': true,
      'x-ls-locale': I18n.locale
    },
    timeout: 5000,
    success: function(arg) {
      var cacheValue, data, err;
      data = arg.data, err = arg.err;
      if (err != null) {
        tracky('ls-cardatron-error', {
          err: err
        });
        return;
      }
      cacheValue = {
        division: division,
        cll: cll,
        ell: ell,
        brand: brand,
        cards: data
      };
      try {
        ls_ttl.set(storageKey, cacheValue, ttl_ms);
      } catch (error) {}
      return setCards(data);
    }
  });
};

module.exports = {
  getCardatronCards: getCardatronCards
};

